<template>
  <div class="preference-info">
  <div v-show="showOverlay" class="pc-overlay"></div>
  <div class="pc-preference">
    <div
      v-for="(preferenceItem, index) in preferenceList"
      class="info-card"
      :key="index"
      :class="`${preferenceItem.name}-card`">
      <div class="card-header">
        <div class="card-icon">
          <i class="iconfont" :class="preferenceItem.icon"></i>
        </div>
      </div>
      <div class="card-body">
        <div
          v-if="preferenceItem.type === 'link'"
          class="preference-label preference-label-link"
          @click="handleSelectClick(preferenceItem)"
        >
          {{ preferenceItem.label }}
        </div>
        <div v-else class="preference-label">{{ preferenceItem.label }}</div>
        <div v-if="preferenceItem.type !== 'link'" v-clickoutside="preferenceItem.selectOutsideClickHandler" class="preference-select">
          <div class="select-label" @click="handleSelectClick(preferenceItem)">
            <span>{{ getSelectLabel(preferenceItem) }}</span>
            <i :class="preferenceItem.showOptionList ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div v-show="preferenceItem.showOptionList" class="select-option-list">
            <div
              v-for="(item, index) in preferenceItem.optionList"
              v-show="item.show"
              class="option-item"
              :key="index"
              @click="handleOptionItemClick(preferenceItem, item)">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
      <el-footer class="footer-btn-group" height="auto">
      <div
        class="back-btn"
        :style="customBackBtnStyle"
        @click="handleBackBtnClick">
        {{ $t('survey.btn.back') }}
      </div>
      <div
        class="next-btn"
        :style="customSaveBtnStyle"
        @click="handleSaveBtnClick">
        {{ $t('survey.btn.save') }}
      </div>
    </el-footer>
  </div>
</template>

<script>
import _ from 'lodash'
import Clickoutside from 'element-ui/src/utils/clickoutside'

export default {
  directives: {
    Clickoutside
  },
  props: {
    companyCustomColor: {
      required: true
    },
    preference: {
      type: Object,
      required: true
    },
    preferenceList: {
      type: Array,
      required: true
    },
    showOverlay: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    customBackBtnStyle () {
      return {
        borderColor: this.companyCustomColor,
        color: this.companyCustomColor
      }
    },
    customSaveBtnStyle () {
      return {
        backgroundColor: this.companyCustomColor,
        color: this.getTextColorByBgColor(this.companyCustomColor)
      }
    }

  },
  created () {
    _.forEach(this.preferenceList, item => {
      item.selectOutsideClickHandler = () => {
        this.handleSelectClickOutside(item)
      }
    })
  },
  methods: {
    getSelectLabel (preferenceItem) {
      const optionItem = _.find(preferenceItem.optionList, { value: this.preference[preferenceItem.dataKey] })
      return optionItem && optionItem.label
    },
    handleSelectClick (preferenceItem) {
      if (preferenceItem.type === 'link') {
        const link = preferenceItem.link
        if (preferenceItem.isInclude) {
          this.$router.push(link)
        } else {
          window.location.href = link
        }
      } else {
        preferenceItem.showOptionList = !preferenceItem.showOptionList
      }
    },
    handleSelectClickOutside (preferenceItem) {
      preferenceItem.showOptionList = false
    },
    handleOptionItemClick (preferenceItem, optionItem) {
      this.preference[preferenceItem.dataKey] = optionItem.value
      preferenceItem.showOptionList = false
    },
    handleBackBtnClick () {
      this.$emit('back')
    },
    handleSaveBtnClick () {
      this.$emit('save')
    },
    getTextColorByBgColor (bgColor) {
      if (!bgColor) {
        return
      }
      bgColor = bgColor.replace('#', '')
      const r = parseInt(bgColor.substr(0, 2), 16)
      const g = parseInt(bgColor.substr(2, 2), 16)
      const b = parseInt(bgColor.substr(4, 2), 16)
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000
      return (yiq >= 160) ? '#000' : '#fff'
    }
  }
}
</script>

<style lang="scss" scoped>
.preference-info{
  position: relative;

  .pc-overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: black;
    opacity: 0.5;
    z-index: 1000;
    top: 0;
    left: 0;
  }

  .pc-preference {
    display: flex;
    padding: 40px 70px 60px;
    box-sizing: border-box;
    min-height: 320px;

    .info-card {
      flex: 1;
      margin: 0 50px;
      border: 1px solid #e5e5e5;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .card-header {
        display: flex;
        padding: 20px 0;
        background: #f8f8f8;

        .card-icon {
          margin: auto;
          padding: 0 10px 10px;
          font-weight: bold;
          color: #808080;
          border-bottom: 2px solid #808080;

          i {
            font-size: 64px;
          }
        }
      }

      .card-body {
        flex: 1;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .preference-label {
          color: #505050;
          font-weight: bold;
          font-size: 22px;

          &.preference-label-link {
            cursor: pointer;
          }
        }

        .preference-select {
          position: relative;

          .select-label {
            display: inline-block;
            padding: 10px 0;
            color: #4d4d4d;

            span {
              vertical-align: middle;
              cursor: pointer;
            }

            i {
              margin-left: 5px;
              vertical-align: middle;
              cursor: pointer;
            }
          }

          .select-option-list {
            width: 100%;
            margin-bottom: 10px;
            background: rgba($color: #000000, $alpha: 0.7);
            position: absolute;
            z-index: 1;

            .option-item {
              height: 30px;
              line-height: 30px;
              margin: 0 75px;
              border-bottom: 1px solid #808080;
              color: #fff;
              cursor: pointer;

              &:last-child {
                border: 0;
              }
            }
          }
        }
      }
    }
  }
  .footer-btn-group {
    display: flex;
    height: 25px;
    padding: 0 35px 20px;
    line-height: 15px;
    font-size: 14px;
    box-sizing: content-box;

    .back-btn {
      width: 45px;
      margin-left: 0;
      margin-right: auto;
      padding: 5px;
      border: 1px solid #000;
      text-align: center;
      cursor: pointer;
    }

    .next-btn {
      width: 45px;
      margin-left: auto;
      margin-right: 0;
      padding: 5px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
